import { TOptionsBase } from 'i18next'
import { $Dictionary } from 'i18next/typescript/helpers'
import i18n from './i18next'

export const cardTranslation = (text: string) => {
    return i18n.t(
        `cards.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`
    )
}
export const sectionTranslation = (
    text: string,
    options?: TOptionsBase & $Dictionary
) => {
    return i18n.t(
        `sections.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`,
        options
    )
}
export const generalTranslation = (
    text: string,
    options?: TOptionsBase & $Dictionary
) => {
    return i18n.t(
        `general.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`,
        options
    )
}

export const editItineraryTranslation = (
    text: string,
    prefix?: string,
    options?: TOptionsBase & $Dictionary
) => {
    const key =
        'edit-itinerary.' +
        (prefix ? prefix + '.' : '') +
        text.replaceAll(/ & /g, '-&-').replaceAll(' ', '-').toLowerCase()
    return i18n.t(key, options)
}
export const editItineraryFieldsTranslation = (
    text: string,
    options?: TOptionsBase & $Dictionary
) => {
    return i18n.t(
        `edit-itinerary.fields.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`,
        options
    )
}
export const editHeaderTranslation = (text: string) => {
    return i18n.t(
        `edit-itinerary.headers.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`
    )
}

export const errorMessageTranslation = (text: string) => {
    return i18n.t(
        `edit-itinerary.errorMessage.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`
    )
}
export const homeTranslation = (text: string) => {
    return i18n.t(
        `home.${text
            .replaceAll(/ & /g, '-&-')
            .replaceAll(' ', '-')
            .toLowerCase()}`
    )
}
